// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___hlHtT","flex":"flex___3TJmQ","label":"label___1Rkm3"};